
<template>
  <div class="limitBox">
    <Timeline v-if="dataList.length>0">
      <Timeline-item v-for="(item,index) in dataList"
                     :key="index">
        <span class="icon_end"
              v-show="item.stateText == '已还清'"></span>
        <div class="box"
             :class="{'color33':item.stateText!='已还清'}">
          <p class="time">{{item.periods}}</p>
          <p class="content">还款金额{{ item.rpyMoney}} <span class="stateText">{{item.stateText}}</span> </p>
          <p class="content">应还日期{{ item.dueDate}}</p>
          <p class="content"
             v-show="item.stateText == '已还清'">还款日期{{ item.rpyDate}}</p>
        </div>
      </Timeline-item>
    </Timeline>
    <div class="noData"
         v-else>
      暂无数据
    </div>
  </div>
</template>

<script>
export default {
  components: {
  },
  data () {
    return {
      dataList: [],
    }
  },
  mounted () {
    this.orderId = this.$route.query.orderId;
    this.util.title('分期账单');
    this.getDetails()
  },
  methods: {
    getDetails () {
      let param = {
        orderId: this.orderId
      }
      let _this = this;
      this.$get('/app/api/v1/staging/details', param)
        .then(res => {
          var e = res;
          if (e.code == 200) {
            _this.dataList = e.data;
          }
          else {
            _this.util.toast({ msg: e.msg })
          }
        })
        .catch(error => { });
    },
    //去借款
    toLoan (item) {
      window.location.href = item.pageUrl;
    },


  }

}
</script>
<style>
.limitBox .ivu-timeline-item-tail {
  border-left: 1px solid #ededed;
}
</style>
<style scoped>
.limitBox {
  background: #fff;
  padding: 0.15rem;
  font-size: 0.13rem;
  color: #929196;
}
.time {
  margin-bottom: 0.17rem;
}
.content {
  padding-left: 5px;
  margin-bottom: 0.13rem;
}
.stateText {
  float: right;
}
.color33 {
  color: #333;
}
.icon {
  background: url("../../assets/img/afterLoan/add_btn.png") no-repeat top center;
  width: 0.16rem;
  height: 0.16rem;
  background-size: 100% 100%;
}
.icon_end {
  display: inline-block;
  background: url("../../assets/img/afterLoan/icon_end.png") no-repeat top
    center;
  width: 0.15rem;
  height: 0.15rem;
  background-size: 100% 100%;
  z-index: 111;
  position: relative;
  left: -0.25rem;
  top: 0.01rem;
}
.noData {
  text-align: center;
  padding-top: 0.5rem;
  font-size: 0.16rem;
}
</style>
